@use 'sass:map';
@use 'ui/styles/core-tokens' as core;

.stepSummary {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 0;

  &Item {
    word-break: break-word;
  }
}

.errorTitle {
  display: flex;
  align-items: center;
  gap: 8px;

  &::before {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: map.get(core.$colors, error);
  }
}
